import React from 'react'
import './deleteMediaDialog.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'; // Import FontAwesomeIcon
import { faTrash } from '@fortawesome/free-solid-svg-icons';

function DeleteMediaDialog({ onClose, onClick,msg="Are you sure to delete this item?" }) {
  const handleCancel=()=>{
    onClose();
  }

  const handleClick=()=>{
    onClick();
  }
  
  return (
    <div >
           <FontAwesomeIcon icon={faTrash} className='trash'/>
    <h4>{msg}</h4>
    <div className='btns'>
        <button className='btn btn-light' onClick={handleCancel}>Cancel</button>
        <button className='btn btn-danger'  onClick={handleClick}>Ok</button>

    </div>
    </div>
  )
}
export default DeleteMediaDialog